import { useState, type ReactNode } from 'react';
import type { PlannedTodayRow } from './today-horizons';

/**
 * One company, one line: its first task as usual, then « +N autres tâches »
 * opens the others just below it, without repeating the company.
 */
export const TodayCompanyGroup = ({ items, render }: {
  items: PlannedTodayRow[];
  render: (item: PlannedTodayRow, nested?: boolean) => ReactNode;
}) => {
  const [open, setOpen] = useState(false);
  const [first, ...others] = items;
  if (!first) return null;
  return (
    <div className="rounded-lg border border-domino-cardBorder bg-domino-white sm:rounded-none sm:border-0">
      {render(first)}
      <div className="px-3.5 pb-2">
        <button type="button" aria-expanded={open} onClick={() => setOpen(!open)}
          className="text-xs text-domino-aubergine underline-offset-2 hover:underline">
          {open ? 'Masquer' : `+${others.length} autre${others.length > 1 ? 's' : ''} tâche${others.length > 1 ? 's' : ''}`}
        </button>
      </div>
      {open && <div className="divide-y divide-domino-cardBorder border-t border-dashed border-domino-cardBorder">{others.map((item) => render(item, true))}</div>}
    </div>
  );
};
